import type { AnalyticsEvent, BotIdTags } from "../types";

import { EventName } from "@homeinstead/shared";

type FormSubmissionResult =
  | "success"
  | "duplicate"
  | "server-error"
  | "validation-error";

type CareerFormSubmitAnalyticsEvent = AnalyticsEvent & {
  franchise_number?: string;
  form_id: string;
  form_submission_result: FormSubmissionResult;
  form_submission_intent: "career";
  lang: string;
  tags: BotIdTags;
};

const CareerFormSubmitEvent = ({
  franchiseNumber,
  result,
  tags,
}: {
  franchiseNumber?: string | undefined;
  result: FormSubmissionResult;
  tags: BotIdTags;
}): CareerFormSubmitAnalyticsEvent => ({
  event: EventName.CAREER_FORM_SUBMIT,
  form_id: "career-inquiry-form",
  form_submission_intent: "career",
  form_submission_result: result,
  franchise_number: franchiseNumber,
  lang: "en",
  tags,
});

export { CareerFormSubmitEvent };
